// Вариант оформления (A «рабочий» / B «постерный») хранится в cookie, чтобы сервер
// сразу отрисовал выбранный вариант и страница не мигала при загрузке.
import { useCookie, useState } from '@/runtime';

export type DcVariant = 'A' | 'B';

import { watch } from 'vue';
export function useDcVariant() {
  const cookie = useCookie<DcVariant>('ff-variant', { default: () => 'A', maxAge: 60 * 60 * 24 * 365, sameSite: 'lax' });
  if (cookie.value !== 'A' && cookie.value !== 'B') cookie.value = 'A';
  const variant = useState<DcVariant>('ff-shared-variant', () => cookie.value);
  watch(variant, value => { cookie.value = value; }, { flush:'sync' });
  return {
    variant,
    toggle: () => { variant.value = variant.value === 'B' ? 'A' : 'B'; },
  };
}
